module.exports = __webpack_public_path__ + "img/hero2.4c4c1abc.jpg";